var map = {
	"./ar.json": 26726,
	"./de.json": 39929,
	"./en.json": 20790,
	"./es.json": 18563,
	"./fr.json": 844,
	"./hu.json": 64626,
	"./it.json": 20504,
	"./ja.json": 8566,
	"./ro.json": 54691,
	"./ru.json": 69672,
	"./tr.json": 12021,
	"./zh_Hans.json": 74709,
	"./zh_Hant.json": 88698
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11845;